export enum MM_STORAGE {
  FORM = 'ck_mmf',
  RESULT = 'ck_mmr',
  COMPLETED = 'ck_mmc',
}
